import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import galleryService from '../../../services/images.services';
import { FaImage } from 'react-icons/fa';

const CustomerGalleryPage = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const fetchImages = async () => {
        try {
            setLoading(true);
            setError('');
            
            const response = await galleryService.getAllImages();
            
            setImages(response.data || []);
        } catch (err) {
            setError('Failed to load images');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchImages();
    }, []);

    return (
        <Container className="py-4">
            
            <div className="mb-4 text-center">
                <h1 className="display-5 fw-bold">Image Gallery</h1>
                <p className="text-muted">Browse our collection of images</p>
            </div>

           
            {error && (
                <Alert variant="danger" className="mb-4">
                    {error}
                </Alert>
            )}

            
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" variant="primary" />
                    <p className="mt-3">Loading images...</p>
                </div>
            ) : (
                <>
                    
                    <Row className="g-3">
                        {images.map((image, index) => (
                            <Col key={image._id} lg={3} md={4} sm={6} xs={12}>
                                <Card className="border-0 shadow-sm">
                                    <div className="image-container" style={{ 
                                        height: '250px', 
                                        overflow: 'hidden',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => window.open(image.url, '_blank')}
                                    >
                                        <img
                                            src={image.url}
                                            alt={`Gallery image ${index + 1}`}
                                            className="img-fluid w-100 h-100"
                                            style={{ 
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                                            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                            loading="lazy"
                                        />
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    
                    {images.length === 0 && !loading && (
                        <div className="text-center py-5">
                            <FaImage size={80} className="text-muted mb-3" />
                            <h4>No images available</h4>
                            <p className="text-muted">
                                Check back later for new images
                            </p>
                        </div>
                    )}
                </>
            )}
        </Container>
    );
};

export default CustomerGalleryPage;